import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import PDPAddToBagSection from 'components/consumer/PDP/PDPAddToBagSection';
import Placeholder from 'components/consumer/Placeholder';
import PDPGalleryLabelsAndViewingCount from 'components/consumer/PDP/PDPGalleryLabelsAndViewingCount';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPRatingsSection from './PDPRatingsSection';
import PDPPriceAndFinance from './PDPPriceAndFinance';
import usePdpSlug from '../state/context/usePdpSlug';
const PDPNameSectionUI = t0 => {
  const $ = _c(31);
  const {
    isEditOrder: t1,
    loading,
    name,
    numberOfReviews,
    pdpIsModularBYOProduct: t2,
    rating,
    reviewsLoading: t3,
    subtitle
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const reviewsLoading = t3 === undefined ? false : t3;
  const location = useLocation();
  const pdpSlug = usePdpSlug();
  const nameFromRouterState = location?.state?.name;
  const isNameLoading = loading && !nameFromRouterState;
  const nameToDisplay = loading ? nameFromRouterState : name;
  let t4;
  if ($[0] !== isNameLoading || $[1] !== nameToDisplay) {
    t4 = isNameLoading ? <Placeholder type="rect" loading={true} className="!w-full lg:!w-[310px]" style={{
      height: "23px"
    }} /> : nameToDisplay;
    $[0] = isNameLoading;
    $[1] = nameToDisplay;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10">{t4}</h1>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MobileAndTabletOnly><div className="flex flex-row items-center lg:hidden"><PDPGalleryLabelsAndViewingCount /></div></MobileAndTabletOnly>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <div className="flex flex-row items-center">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== subtitle) {
    t8 = subtitle && <div className="pb-1.5 pl-5 md:pl-8 lg:pl-0.5"><span className="text-sm">{subtitle}</span></div>;
    $[8] = subtitle;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== numberOfReviews || $[11] !== pdpIsModularBYOProduct || $[12] !== rating || $[13] !== reviewsLoading) {
    t9 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><PDPRatingsSection numberOfReviews={numberOfReviews} pdpIsModularBYOProduct={pdpIsModularBYOProduct} rating={rating} reviewsLoading={reviewsLoading} /></div>;
    $[10] = numberOfReviews;
    $[11] = pdpIsModularBYOProduct;
    $[12] = rating;
    $[13] = reviewsLoading;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isEditOrder || $[16] !== loading || $[17] !== pdpIsModularBYOProduct || $[18] !== pdpSlug) {
    t10 = <PDPPriceAndFinance isEditOrder={isEditOrder} key={pdpSlug} loading={loading} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[15] = isEditOrder;
    $[16] = loading;
    $[17] = pdpIsModularBYOProduct;
    $[18] = pdpSlug;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isEditOrder || $[21] !== loading) {
    t11 = !isEditOrder && <DesktopOnly><div className="ml-2 max-[1023px]:hidden"><PDPAddToBagSection stickyDesktopButtonOnly={true} pageLoading={loading} /></div></DesktopOnly>;
    $[20] = isEditOrder;
    $[21] = loading;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="bg-white pt-4 px-0 pb-3 sticky top-0 z-[999] lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t13 = <>{t7}{t8}{t9}{t12}</>;
    $[26] = t12;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
PDPNameSectionUI.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  numberOfReviews: PropTypes.number,
  pdpIsModularBYOProduct: PropTypes.bool,
  rating: PropTypes.number,
  reviewsLoading: PropTypes.bool,
  subtitle: PropTypes.string
};
export default PDPNameSectionUI;